import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import translations from '../../translations/de';
import Paths from '../../constants/paths';
import Item from '../../components/Item';
import Select from '../../components/Select';
import parkingAPI from '../../api/parking';

// Bulk-import pre-existing parking passes from a CSV with a header row.
// Recognised columns: type, season_id, game_id, first_name, last_name, email, phone
const COLUMNS = ['type', 'season_id', 'game_id', 'first_name', 'last_name', 'email', 'phone'];
const NUMERIC = ['season_id', 'game_id'];

const ImportPasses = ({ store }) => {
    const history = useHistory();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fields, setFields] = useState([]);
    const [fieldId, setFieldId] = useState(null);
    const [rows, setRows] = useState([]);
    const [fileName, setFileName] = useState('');

    useEffect(() => {
        !store.dataLoaded && store.setDataLoaded();
        parkingAPI
            .getFields()
            .then((res) => setFields(res.data))
            .catch(() => {});
    }, [store]);

    const onFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setFileName(file.name);
        setError(null);
        const reader = new FileReader();
        reader.onload = () => {
            const lines = String(reader.result)
                .split(/\r?\n/)
                .map((l) => l.trim())
                .filter(Boolean);
            if (lines.length < 2) {
                setRows([]);
                setError('CSV: Kopfzeile + mindestens eine Zeile erforderlich.');
                return;
            }
            const header = lines[0].split(',').map((h) => h.trim().toLowerCase());
            const parsed = lines.slice(1).map((line) => {
                const cells = line.split(',');
                const row = {};
                header.forEach((col, i) => {
                    if (!COLUMNS.includes(col)) return;
                    const raw = (cells[i] ?? '').trim();
                    if (raw === '') return;
                    row[col] = NUMERIC.includes(col) ? Number(raw) : raw;
                });
                return row;
            });
            setRows(parsed);
        };
        reader.readAsText(file);
    };

    const submit = () => {
        setError(null);
        if (!fieldId) {
            setError(translations.required + ': ' + translations.parking_field);
            return;
        }
        if (!rows.length) {
            setError(translations.required + ': CSV');
            return;
        }
        setLoading(true);
        store
            .importPasses({ parking_field_id: fieldId, rows })
            .then(() => {
                setLoading(false);
                history.push(Paths.PARKING_FIELDS);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    };

    return (
        <Item
            links={[{ path: Paths.PARKING_FIELDS, name: translations.parking_fields }]}
            name="Import Liste"
            itemModel={{}}
            edit={true}
            onSubmit={submit}
            onCancel={() => history.goBack()}
            error={error}
            loading={loading}
        >
            <div style={{ maxWidth: '520px' }}>
                <Select
                    label={translations.parking_field}
                    options={fields.map((f) => ({ label: f.name, value: f.id }))}
                    onChange={(e) => setFieldId(e.value)}
                />
                <p style={{ color: '#888', fontSize: '13px', margin: '10px 0' }}>
                    Spalten: {COLUMNS.join(', ')}
                </p>
                <div style={{ margin: '15px 0' }}>
                    <input type="file" accept=".csv,text/csv" onChange={onFile} />
                    {fileName && (
                        <p style={{ color: '#333', marginTop: '8px' }}>
                            {fileName} — {rows.length} Zeilen
                        </p>
                    )}
                </div>
            </div>
        </Item>
    );
};

export default observer(ImportPasses);
